var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!../../../45/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../45/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-23ab6776\",\"scoped\":false,\"hasInlineConfig\":false}!../../../45/node_modules/vue-loader/lib/selector?type=styles&index=0!./SideList.vue")
}
var normalizeComponent = require("!../../../45/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../45/node_modules/vue-loader/lib/selector?type=script&index=0!./SideList.vue"
import __vue_script__ from "!!babel-loader!../../../45/node_modules/vue-loader/lib/selector?type=script&index=0!./SideList.vue"
/* template */
import __vue_template__ from "!!../../../45/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-23ab6776\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../45/node_modules/vue-loader/lib/selector?type=template&index=0!./SideList.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/SideList.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23ab6776", Component.options)
  } else {
    hotAPI.reload("data-v-23ab6776", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SideList.vue
// module id = null
// module chunks = 